<div id="wrapper">
    <div class="allcont">
        <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile"></app-menu>
        <div class="border-type">
            <app-tab-nav (updatePostpaid)="this.postpago=$event" (updatePrepaid)="this.prepago=$event"
                (updateFixed)="this.telefoniaFijo=$event" (updateTotalAccountList)="this.totalAccountList=$event"
                (updateCurrentList)="this.currentList=$event" (updateSelectBan)="this.selectBan=$event"
                (updateInitializeData)="this.initializeData()">
            </app-tab-nav>
        </div>
        <app-add-product *ngIf="this.totalAccountList==0"></app-add-product>
        <div class="basicrow m-top" *ngIf="((this.postpago==true) ||
      (this.telefoniaFijo==true)) && this.totalAccountList> 0 ">
            <div class="container">
                <div class="basicr-line-i">
                    <div class="fulltitle f-btitle autodef">
                        <span class="icon-dash-14"></span> Resumen de Factura
                    </div>
                    <div class="pull-right">
                        <label class="label-r sidenmbr vcenter w-auto">
                            <span class="tabcell">
                                N&uacute;mero de Cuenta
                            </span>
                        </label>
                        <div class="autorow subsc mob-wid pull-right">
                            <div *ngIf="this.totalAccountList> 0">
                                <select [(ngModel)]="this.selectBan" (change)="this.refreshDataTo($event)" class="sel-f"
                                    style="background-image:url(/assets/images/selectabarrw.png)">
                                    <option *ngFor="let list of this.currentList" [ngValue]="list.account">
                                        {{list.account}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="basicrow mbott m-top" id="last-div" *ngIf="((this.postpago==true) || (this.telefoniaFijo==true) &&
      this.totalAccountList> 0)">
            <div class="container">
                <div class="basicrow bordsdef f-reg f-black roboto-r m-top">
                    <div class="basicrow allpads">
                        <div class="basicrow">
                            <div class="autorow pull-left factdef roboto-b">
                                Fecha de Facturaci&oacute;n
                            </div>
                            <div class="autorow pull-right factdef roboto-b">
                                {{this.cycleStartDateField}}
                            </div>
                        </div>
                        <div class="basicrow m-top-ii">
                            <div class="autorow pull-left factdef roboto-b">
                                Fecha de Vencimiento
                            </div>

                            <div class="autorow pull-right factdef roboto-b">
                                {{this.billDueDateField}}
                            </div>
                        </div>
                        <div class="basicrow m-top-ii">
                            <div class="autorow pull-left factdef roboto-b">
                                Fecha de Corte
                            </div>
                            <div class="autorow pull-right factdef roboto-b">
                                {{this.cycleEndDateField}}
                            </div>
                        </div>
                        <div class="basicrow m-top">
                            <div class="logline full"></div>
                        </div>
                        <div class="basicrow m-top">
                            <div class="autorow pull-left factdef roboto-b">
                                Balance Pendiente
                            </div>
                            <div class="autorow pull-right factdef roboto-b f-red">
                                {{this.billBalanceField.replace(',','')|currency}}
                            </div>
                        </div>
                    </div>
                    <div class="basicrow">
                        <div class="basicrow allpads topbord-i">
                            <div class="autorow pull-left factdef roboto-r">
                                Ciclo de Facturaci&oacute;n
                            </div>
                            <div class="autorow pull-right factdef roboto-b">
                                {{this.cycleDateField}}
                            </div>
                        </div>
                        <div class="basicrow allpads">
                            <div class="autorow pull-left factdef roboto-r">
                                &Uacute;ltimo Pago
                            </div>
                            <div class="autorow pull-right factdef roboto-b">
                                {{this.lastPaymentAmountField |currency}}
                            </div>
                        </div>
                    </div>
                    <div class="basicrow graybg-i allpads topbord-i">
                        <div class="autorow m-top-u pull-left factdef roboto-b f-big">
                            Monto a Pagar
                        </div>
                        <div class="utorow pull-right factdef f-red roboto-m f-semi">
                            <div class="basicrow rel m-top-u">
                                <img matTooltipShowDelay="500" matTooltipHideDelay="500" mat-raised-button matTooltip="Ahora puedes abonar hasta $2000.00. Si la cantidad indica CR, significa que usted tiene crédito en su cuenta." class="q-t" width="100%" src="../../assets/images/tooltip1.png">
                                <input [appOnlyAmount] [(ngModel)]="this.amountPayable2" value="{{this.amountPayable2}}" (ngModelChange)="this.checkAmount()" (change)="validateAmount()" class="inp-f billmonto">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-u-ii button">
                    <div>
                        <div class="invoice-button">
                            <a (click)="this.doPayment();" class="btns red vcenter" [ngClass]="{'red': this.dopaymentmount,'gray':
                !this.dopaymentmount}">
                                <span class="tabcell">
                                    Paga tu Factura Aqu&iacute;
                                </span>
                            </a>
                        </div>
                    </div>
                    <div>
                        <div class="debit-direct-button">
                            <a routerLink="/direct-debit" class="btns red vcenter">
                                <span class="tabcell">
                                    Debito Directo
                                </span>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="basicrow m-top-u-ii button">
                    <div class="buttons-extra">
                        <div class="boton-desc">
                            <a routerLink="/billshistory" class="btns
                blue vcenter">
                                <span class="tabcell">
                                    Descarga tu Factura
                                </span>
                            </a>
                        </div>
                    </div>
                    <div>
                        <div class="boton-hist">
                            <a routerLink="/paymenthistory" class="btns blue vcenter">
                                <span class="tabcell">
                                    Hist&oacute;rico de Pagos
                                </span>
                            </a>
                        </div>
                    </div>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>
